import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalService } from "ngx-bootstrap/modal";
import { first } from 'rxjs/operators';
import { NdmsSafeSubscriber } from '../../../../../../projects/shared/core/interfaces/ndms-safe-subscriber';
import { ToastService } from '../../../../../../projects/shared/core/services/toast.service';
import { UserService } from '../../../../../../projects/rms/app/api/services/user.service';
import { UserModel } from '../../../../../../projects/rms/app/api/models/user-model';
import { SearchRespondersModalComponent } from '../search/search-responders-modal.component';

@Component({
  selector: 'user-apps-list',
  templateUrl: './user-apps-list.component.html',
  styleUrls: ['./user-apps-list.component.css']
})
export class UserAppsListComponent extends NdmsSafeSubscriber {
  @Input() set model(value: any[]) {
    if (value) {
      this.userApps = value;
    }
  }
  @Input() userName: string;

  @Output() refresh = new EventEmitter<boolean>();

  userApps: any[] = [];

  columns: any[] = [
    { header: "App", field: "application" },
    { header: "Responder Name", field: "responderName" },
    { header: "Account Status", field: "accountStatus" },
    { header: "Primary Email Address", field: "primaryEmail" },
    { header: "Secondary Email Address", field: "secondaryEmail" },
    { header: "Status", field: "responderStatus" },
    { header: "Legacy", field: "isLegacy" }
  ];

  constructor(
    private _rmsUserService: UserService,
    private _modalService: BsModalService,
    private _toastService: ToastService) {
    super();
  }

  onAssignClick(app) {
    this.findRmsUsers(app.userName).then(data => {
      let rmsUser: UserModel = {};
      if ((data as UserModel[]).length === 0) {
        rmsUser = {
          accountStatus: 1,
          accountJustification: "Assigned",
          firstName: app.firstName,
          lastName: app.lastName,
          responderId: app.responderId,
          userName: app.userName,
          active: true
        }
        this.addRmsUser(rmsUser)
          .then(() => this.addRmsUser(rmsUser)
            .then(() => this.refresh.emit(true)));
      }
      else {
        rmsUser = data[0];
        rmsUser.responderId = app.responderId;
        this.addRmsUser(rmsUser)
          .then(() => this.refresh.emit(true));
      }
    });
  }

  onAssignNewClick(event?) {
    let activeElement = document.activeElement;
    let pointerType = event ? event.pointerType : '';

    const modal = this._modalService.show(SearchRespondersModalComponent, { backdrop: "static", class: "gray modal-lg" });

    this._modalService.onHide.pipe(first()).subscribe(() => {
      if (activeElement && activeElement instanceof HTMLElement) {
        activeElement.focus();
        if (pointerType == "mouse") activeElement.blur();
      }
    });
    this.safeSubscribe(modal.content.selection, selectedResponder => {
      let rmsUser = {
        accountStatus: 1,
        accountJustification: "Assigned",
        firstName: selectedResponder.firstName,
        lastName: selectedResponder.lastName,
        responderId: selectedResponder.id,
        userName: this.userName,
        active: true
      }
      modal.hide();
      this.addRmsUser(rmsUser)
          .then(() => this.addRmsUser(rmsUser)
            .then(() => this.refresh.emit(true)));
    });
    this.safeSubscribe(modal.content.cancel, () => modal.hide());
  }

  onReassignClick(app, event?) {
    let activeElement = document.activeElement;
    let pointerType = event ? event.pointerType : '';

    const modal = this._modalService.show(SearchRespondersModalComponent, { backdrop: "static", class: "gray modal-lg" });

    this._modalService.onHide.pipe(first()).subscribe(() => {
      if (activeElement && activeElement instanceof HTMLElement) {
        activeElement.focus();
        if (pointerType == "mouse") activeElement.blur();
      }
    });
    this.safeSubscribe(modal.content.selection, selectedResponder => {
      let rmsUser = {
        accountStatus: 1,
        accountJustification: "Assigned",
        firstName: app.firstName,
        lastName: app.lastName,
        responderId: app.responderId,
        userName: app.userName,
        active: true
      }
      modal.hide();
      this.reassign(rmsUser, selectedResponder.id)
        .then(() => this.refresh.emit(true));
    });
    this.safeSubscribe(modal.content.cancel, () => modal.hide());
  }

  onUnassignClick(app) {
    console.log(app);
    this.unassign(app.responderId)
        .then(() => this.refresh.emit(true));
  }

  private addRmsUser(rmsUser: UserModel) {
    return new Promise<void>((resolve, reject) => {
      this.safeSubscribe(this._rmsUserService.Add(rmsUser), data  => {
        resolve();
        },
        error => {
          this._toastService.showError(error);
          reject();
        });
    });
  }

  private findRmsUsers(userName: string) {
    return new Promise((resolve, reject) => {
      let queryParams: UserService.QueryParams = Object.assign({}, {
        UserName: userName,
        Page: 1,
        PageSize: 10,
        SortBy: "LastName",
        SortOrder: 1
      });
      this.safeSubscribe(this._rmsUserService.Query(queryParams), data  => {
        return resolve(data.model);
        },
        error => {
          this._toastService.showError(error);
          reject();
        });
    });
  }

  private reassign(rmsUser: UserModel, responderId: number) {
    return new Promise<void>((resolve, reject) => {
      let reassignParams: UserService.ReassignUserParams = Object.assign({}, {
        responderId: responderId,
        obj: rmsUser
      });
      this.safeSubscribe(this._rmsUserService.ReassignUser(reassignParams), data  => {
        resolve();
        },
        error => {
          this._toastService.showError(error);
          reject();
        });
    });
  }

  private unassign(responderId: number) {
    return new Promise<void>((resolve, reject) => {
      this.safeSubscribe(this._rmsUserService.UnassignUser(responderId),
        () => {
          resolve();
        },
        error => {
          this._toastService.showError(error);
          reject(error);
        });
    });
  }

}
